import React, {Component} from 'react';
import {
  GridList,
  GridTile,
  GridTileIcon,
  GridTilePrimary,
  GridTilePrimaryContent,
  GridTileSecondary,
  GridTileTitle
} from 'rmwc/GridList';
import { Grid, GridCell } from 'rmwc/Grid';
import Result from '../Result/Result';
import { Typography } from 'rmwc/Typography';
//import Sizing from '../utils/Sizing';

const divStyle = {
  'paddingTop': '15px',
  margin: '0 auto',
};

const backGroundImg = 'https://material-components-web.appspot.com/images/1-1.jpg'

const gridTileStyle = {
  backgroundImage: `url(${backGroundImg})`,
  paddingTop: '16px',
  color: 'white'
}


export default class ResultList extends Component {
  render() {
    const resultsArr = [
      ["Minimum irradiance", this.props.minRad],
      ["Annual average", this.props.avgAnnual],
      ["Number of panels", this.props.numPanels],
      ["Optimal tilt", this.props.optTilt],
      //[`${this.props.numBatt[2]} parallel conn.`, Number(this.props.numBatt[0])]
    ];
    return(
      <GridList twolineCaption="true" tileAspect="4x3">
  {resultsArr.map((val, i) => (
    <GridTile key={i} style={divStyle}>
      <GridTilePrimary>
        <GridTilePrimaryContent style={gridTileStyle}>
          <Typography use="display2">{isNaN(val[1]) ? 0 : val[1]}</Typography>
        </GridTilePrimaryContent>
      </GridTilePrimary>
      <GridTileSecondary>
        <GridTileTitle>{val[0]}</GridTileTitle>
      </GridTileSecondary>
    </GridTile>
  ))}
  <GridTile key={4} style={divStyle}>
    <GridTilePrimary>
      <GridTilePrimaryContent style={gridTileStyle}>
        <Typography use="display2">{isNaN(Number(this.props.numBatt[0]))? 0 : Number(this.props.numBatt[0])}Ah</Typography>
      </GridTilePrimaryContent>
    </GridTilePrimary>
    <GridTileSecondary>
      <GridTileTitle>{isNaN(this.props.numBatt[2]) ? 0 : this.props.numBatt[2]} parallel conn.</GridTileTitle>
      <p>{isNaN(this.props.numBatt[1]) ? 0 : this.props.numBatt[1]} in series</p>
    </GridTileSecondary>
  </GridTile>
</GridList>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ResultList/ResultList.js